module.exports = __webpack_public_path__ + "static/media/gallery09.3fc758e8.jpg";